<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <b-form @submit.prevent.stop="create">
      <b-form-group
        id="input-group-4"
        label="Selecione uma Obra"
        label-for="input-5"
      >
        <!-- {{obras}} -->
        <b-form-select
          id="input-5"
          v-model="estoque.obra"
          class="input-color"
          type="text"
          placeholder="Enter items"
          required
        >
          <b-form-select-option
            v-for="obra in obras"
            :key="obra._id"
            :value="obra"
          >
            {{ obra.nome }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Informe o código do insumo:">
        <b-input-group class="mb-2" label="Insumo">
          <b-form-input
            v-model="codigoInsumo"
            class="input-color"
            placeholder="Digite o código do insumo"
            onchange="this.value = this.value.replace(/[^\d.]/g, '');"
            @keydown.enter.prevent="pesquisarInsumoId(codigoInsumo)"
          />
          <b-input-group-append>
            <b-button
              style="background-color: #113d63"
              variant="info"
              @click="pesquisarInsumoId(codigoInsumo)"
            >
              Pesquisar Insumo
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group
        id="input-group-1"
        label="Insumo"
        label-for="input-1"
        :description="
          estoque.insumo !== undefined
            ? `Insumo selecionado: ${estoque.insumo.codigo} - ${estoque.insumo.descricao} - ${estoque.insumo.unidade} `
            : 'Pesquise um insumo'
        "
      >
        <b-form-select
          id="input-1"
          v-model="estoque.insumo"
          type="text"
          class="input-color"
        >
          <b-form-select-option
            v-for="insumo in insumos"
            :key="insumo._id"
            class="input-color"
            :value="insumo"
          >
            {{
              insumo.descricao_pai
                ? `${insumo.codigo} | ${insumo.descricao_pai} - ${insumo.descricao}`
                : `${insumo.codigo} | ${insumo.descricao}`
            }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group id="input-group-1" label="Quantidade" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="estoque.qtde"
          min="1"
          class="input-color mb-5"
          type="number"
          required
        ></b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary" :disabled="isDisabled"
        >Salvar</b-button
      >
    </b-form>
  </div>
</template>
<script>
import alertMixin from '@/src/mixins/alertMixin'
import InsumoService from '@/src/services/serviceInsumoObra'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import serviceObra from '@/src/services/serviceObra'
import servicesMateriaisDisponiveis from '@/src/services/servicesMateriaisDisponiveis'

export default {
  mixins: [alertMixin],
  props: {
    setLoading: {
      type: Function,
      default: () => {},
    },
    close: {
      type: Function,
      default: () => {},
    },
    reload: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      codigoInsumo: '',
      estoque: {
        obra: null,
        insumo: undefined,
        qtde: '',
      },
      texto: '',
      obras: [],
      insumos: [],
      units: [],
      tipoPesquisa: 'codigo',
      isDisabled: false,
    }
  },

  created() {
    this.listaObra()
    this.estoque = {
      obra: null,
      insumo: undefined,
      qtde: '',
    }
  },

  methods: {
    async pesquisarInsumoId(codigo) {
      this.isDisabled = true
      if (
        this.estoque.obra === undefined ||
        this.estoque.obra === null ||
        this.estoque.obra === ''
      ) {
        this.errorMessage('Selecione uma Obra')
        this.isDisabled = false
        return
      }
      if (codigo === '') {
        this.errorMessage('Digite o código do insumo')
        this.isDisabled = false
        return
      }

      let idFilial

      if (!this.estoque.obra.filial) {
        this.errorMessage('Selecione uma Obra')
        this.isDisabled = false
        return
      }
      else if (this.estoque.obra.filial) {
        if (this.estoque.obra.filial._id) {
          idFilial = this.estoque.obra.filial._id
        } else if (typeof this.estoque.obra.filial === 'string') {
          idFilial = this.estoque.obra.filial
        }
      }

      if (idFilial === undefined) {
        this.errorMessage('Não foi possível identificar a Filial da Obra. Contate o suporte.')
        this.isDisabled = false
        return
      }
      this.setLoading(true)
      let { data: resultado } = await InsumoService.buscaCodigo(
        codigo,
        'saida',
        idFilial ? 'filial' : false,
        idFilial
      ).catch((err) => {
        this.errorMessage(err.response.data.error.message)
        this.isDisabled = false
        this.setLoading(false)
      })
      this.setLoading(false)
      if (resultado.data === undefined) {
        this.errorMessage('Erro ao Buscar Insumo')
        this.isDisabled = false
        return
      }
      if (
        resultado.data.subItens !== undefined &&
        resultado.data.subItens.length > 0
      ) {
        this.insumos = resultado.data.subItens
        this.insumos.unshift(resultado.data)
        this.isDisabled = false
        return
      }

      this.insumos = [resultado.data]
      this.isDisabled = false
    },

    async listaObra() {
      this.setLoading(true)
      try {
        let {
          data: { data },
        } = await serviceObra.list(
          this.$store.state.filter,
          this.$store.state.filial
        )
        this.obras = data

        this.setLoading(false)
      } catch (error) {
        this.setLoading(false)
        this.errorMessage('Erro ao Buscar Obras')
      }
    },

    async create() {
        this.isDisabled = true
        this.setLoading(true)
        if (
          this.estoque.obra === undefined ||
          this.estoque.obra === null ||
          this.estoque.obra === ''
        ) {
          this.errorMessage('Selecione uma Obra')
          return
        } else if (!this.estoque.insumo) {
          this.errorMessage('Selecione um Insumo')
          return
        } else if (this.estoque.qtde === '') {
          this.errorMessage('Informe a Quantidade')
          return
        }

        await servicesMateriaisDisponiveis.create(
          this.estoque.insumo,
          this.estoque.obra,
          this.estoque.qtde
        ).then((_response) => {
          this.successMessage('Estoque Salvo com Sucesso')
          this.codigoInsumo = ''
          this.codigo = ''
          this.estoque.obra = null
          this.estoque.insumo = null
          this.estoque.qtde = ''
          this.insumos = []
          this.setLoading(false)
          this.close()
          this.isDisabled = false
          this.reload()
        }).catch((error) => {
          console.log(error)
          this.errorMessage(error.response.data.error.message)
          this.setLoading(false)
          this.isDisabled = false
        })
    },
  },
}
</script>
<style scoped>
.input-color {
  background-color: rgba(78, 78, 199, 0.212);
}
</style>
